"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Fields, System } from 'Constants/objects';
import { isEmptyObject } from "D5Utils/functions";
var defLang = navigator.language || navigator.browserLanguage;

var UserSettingsClass =
/*#__PURE__*/
function () {
  function UserSettingsClass() {
    _classCallCheck(this, UserSettingsClass);

    if (isEmptyObject(this.getRegionalSettings())) {
      this.setSettings(System.USER_SETTINGS.REGIONAL_SETTINGS, _defineProperty({}, Fields.RegionalLocale, defLang));
    }

    if (!this.getApplicationLang()) {
      this.setSettings(System.USER_SETTINGS.APPLICATION_LANG, 'en');
    }
  }

  _createClass(UserSettingsClass, [{
    key: "_createSettingName",
    value: function _createSettingName(name) {
      return name.toLowerCase();
    }
  }, {
    key: "setSettings",
    value: function setSettings(name, value) {
      var appSets = JSON.parse(localStorage.getItem(System.USER_SETTINGS.APP_SETTINGS) || "{}");
      appSets[this._createSettingName(name)] = value;
      localStorage.setItem(System.USER_SETTINGS.APP_SETTINGS, JSON.stringify(appSets));
    }
  }, {
    key: "getSettings",
    value: function getSettings() {
      return JSON.parse(localStorage.getItem(System.USER_SETTINGS.APP_SETTINGS) || "{}");
    }
  }, {
    key: "getRegionalSettings",
    value: function getRegionalSettings() {
      return this.getSettings()[this._createSettingName(System.USER_SETTINGS.REGIONAL_SETTINGS)] || {};
    }
  }, {
    key: "getApplicationLang",
    value: function getApplicationLang() {
      return this.getSettings()[this._createSettingName(System.USER_SETTINGS.APPLICATION_LANG)];
    }
  }]);

  return UserSettingsClass;
}();

export var UserSettings = new UserSettingsClass();